// Modules
import { gql } from '@apollo/client'

export const ConfirmToken = gql`
    mutation confirmToken($dataConfirmation: PatientToken!, $logInfo: LogInfoInput) {
        confirmToken(patientToken: $dataConfirmation, logInfo: $logInfo) {
            message
            authentication {
                access_token
                refresh_token
            }
        }
    }
`
